const DOMI_YELLOW_THEME = 'zh-yellow';
const DOMI_BLUE_THEME = 'en-blue';

const getDomiLanguageTheme = locale => (
    typeof locale === 'string' && /^zh(?:[-_]|$)/i.test(locale) ?
        DOMI_YELLOW_THEME :
        DOMI_BLUE_THEME
);

export {
    DOMI_BLUE_THEME,
    DOMI_YELLOW_THEME,
    getDomiLanguageTheme
};
